import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ReportingNav } from './components/ReportingNav';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { BordereauxPage } from './pages/BordereauxPage';
import { useReportingStore } from './reportingStore';

export const Reporting: React.FC = () => {
  const loaded = useReportingStore(s => s.loaded);
  const fetchRecords = useReportingStore(s => s.fetchRecords);
  const fetchReferenceData = useReportingStore(s => s.fetchReferenceData);

  useEffect(() => {
    // Filter changes refetch through the store, so only the first mount needs to.
    if (!loaded) void fetchRecords();
    void fetchReferenceData();
  }, [loaded, fetchRecords, fetchReferenceData]);

  return (
    <div>
      <ReportingNav />
      <Routes>
        <Route index element={<AnalyticsPage />} />
        <Route path="bordereaux" element={<BordereauxPage />} />
        <Route path="*" element={<AnalyticsPage />} />
      </Routes>
    </div>
  );
};
